import type { ButtonHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

interface FilterPillProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active: boolean
  /** Light-only active treatment retained by legacy surfaces. */
  lightActiveClassName?: string
  /** Light-only inactive treatment retained by legacy surfaces. */
  lightInactiveClassName?: string
}

/**
 * Shared compact filter toggle. Dark mode intentionally follows the Tasks
 * filter treatment; callers may preserve their existing Light appearance.
 */
export function FilterPill({
  active,
  lightActiveClassName = 'bg-gray-800 text-white',
  lightInactiveClassName = 'bg-gray-100 text-gray-600 hover:bg-gray-200',
  className,
  type = 'button',
  ...props
}: FilterPillProps) {
  return (
    <button
      type={type}
      aria-pressed={active}
      className={cn(
        'rounded-full px-3 py-1 text-xs font-medium transition-colors',
        active
          ? cn(
              lightActiveClassName,
              'dark:bg-primary dark:text-primary-foreground'
            )
          : cn(
              lightInactiveClassName,
              'dark:text-secondary-foreground dark:bg-zinc-700 dark:hover:bg-zinc-600'
            ),
        className
      )}
      {...props}
    />
  )
}
